import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	rootContainer: {
		paddingBottom: theme.spacing(0.5)
	},
	actionButtonsContainer: {
		width: 'auto',
		'& .MuiGrid-item:nth-last-child(2)': {
			marginRight: theme.spacing(1)
		}
	}
}));
